import Axios from "axios";
import { ApiResultModel } from "../../models/common.model";
import { APIBASE_URL, Ping_URL } from "../../config/cacheKey";

export const GetSupportInfo = async (): Promise<boolean> => {
    return await Axios.post<ApiResultModel<boolean>>(
        APIBASE_URL + Ping_URL
    ).then((result) => {
        return result.data.data;
    });
};